export function applyExtractedProduct(current, extracted, dirtyFields) {
  const dirty = dirtyFields instanceof Set ? dirtyFields : new Set(dirtyFields || [])
  const product = extracted || {}
  return {
    ...current,
    name: dirty.has('name') ? current.name : (product.name || current.name),
    price: dirty.has('price') ? current.price : (product.price ?? current.price),
    image_url: dirty.has('image_url') ? current.image_url : (product.image_url || current.image_url),
    image_key: dirty.has('image_url') ? current.image_key : (product.image_key || current.image_key || ''),
    link: current.link,
  }
}
